module.exports = __webpack_public_path__ + "static/media/chatWindowPlaceholder.6dbfd21f.svg";